import React from 'react';
import { UseControllerProps } from 'react-hook-form';
import { Input, InputProps } from 'semantic-ui-react';
import { useFilterController } from '../useFilterForm';
import { getInputId } from './getInputId';

interface Props {
  inputProps: InputProps;
  controllerProps: UseControllerProps;
  transformInput?: (value: any) => string;
  transformOutput?: (value: string) => any;
  className?: string;
}

const transformStub = (value: any) => value;

export const InputField = ({ inputProps, controllerProps, transformInput = transformStub, transformOutput = transformStub }: Props) => {
  const controller = useFilterController(controllerProps);

  const onChange = ({ target: { value } }: any) => {
    controller.field.onChange({ target: { value: transformOutput(value) } });
  };

  const onBlur = (e: any) => {
    inputProps?.onBlur?.(e);
    controller.field.onBlur();
  };

  const value = transformInput(controller.field.value) ?? '';
  return (
    <Input
      {...inputProps}
      onBlur={onBlur}
      onChange={onChange}
      value={value}
      id={getInputId(controllerProps.name)}
      data-testid={getInputId(controllerProps.name)}
    />
  );
};
